<script>
import { BTable } from "bootstrap-vue";

export default {
  name: "EntrepriseMarcheInfosTable",
  components: { BTable },
  data: () => ({
    pageSize: 10,
    pageIndex: 1,
    sortParams: [],
    selectedRows: [],
    pageSizes: [10, 25, 50, 100],
    fields: [
      { label: '', key: 'num', sortable: false },
      { label: 'SIRET', key: 'entreprise.siret', sortable: false },
      { label: 'Marché', key: 'marche.reference', sortable: false },
      { label: 'PME', key: 'pme', sortable: false },
      { label: 'Siège en IDF', key: 'francilienne' },
      { label: 'Agence en IDF', key: 'agenceIdf' },
      { label: 'Chiffre d\'affaire', key: 'chiffreAffaire', sortable: true },
      { label: 'Effectif', key: 'effectif', sortable: true },
    ]
  }),
  props: {
    totalElements: {
      type: Number,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  computed: {
    isAllSelected() {
      return this.data.length === this.selectedRows.length
    }
  },
  methods: {
    onPageChange() {
      this.search()
    },
    onSort(sort) {
      this.sortParams = [{ sortBy: sort.sortBy, sortDirection: sort.sortDesc ? 'desc' : 'asc' }]
      this.search()
    },
    search() {
      this.$emit('search', { sortParams: this.sortParams, pageSize: this.pageSize, pageIndex: this.pageIndex - 1 })

    },
    onRowSelected(rows) {
      this.selectedRows = rows
      this.$emit('rowSelected', rows)
    },
    onSelectAll() {
      if (this.isAllSelected) {
        this.$refs.table.clearSelected()
      } else {
        this.$refs.table.selectAllRows()
      }
    }
  }
}
</script>

<template>
  <div>
    <b-row class="align-content-center">
      <b-col cols="2">
        <b-form-select v-model="pageSize" :options="pageSizes" @change="search()">
        </b-form-select>
      </b-col>
      <b-col cols="6" offset="1">
        <b-pagination v-model="pageIndex" :total-rows="totalElements" :per-page="pageSize" :limit="10" align="center"
          @input="search()"></b-pagination>
      </b-col>
      <b-col cols="2" offset="1">
        <b-button variant="primary" @click="onSelectAll">Tout {{ isAllSelected ? 'déselectionner' :
          'sélectionner' }}</b-button>
      </b-col>
    </b-row>

    <b-table ref="table" selectable striped hover :no-local-sorting="true" :per-page="pageSize" :items="data"
      :fields="fields" @row-selected="onRowSelected" @sort-changed="onSort">
      <template v-slot:cell(num)="row">
        <b-checkbox :checked="row.rowSelected" @change="(ev) => ev ? row.selectRow() : row.unselectRow()"></b-checkbox>
      </template>
      <template v-slot:cell(pme)="row">
        <span v-if="row.value">Oui</span>
        <span v-else>Non</span>
      </template>
      <template v-slot:cell(francilienne)="row">
        <span v-if="row.value">Oui</span>
        <span v-else>Non</span>
      </template>
      <template v-slot:cell(agenceIdf)="row">
        <span v-if="row.value">Oui</span>
        <span v-else>Non</span>
      </template>
      <template v-slot:cell(chiffreAffaire)="row">
        <span v-if="row.value">{{ row.value }}</span>
        <span v-else>Inconnu</span>
      </template>
      <template v-slot:cell(effectif)="row">
        <span v-if="row.value">{{ row.value }}</span>
        <span v-else>Inconnu</span>
      </template>
    </b-table>
  </div>
</template>
